export default {
  newYear: {
    apply: {
      title: '新春行大運行山活動',
      inviteConfirm: '邀請你一起參與',
      home: {
        title: '新春行大運',
        bg: 'static/newYear/7296-HikingSpring-750x460-tc.jpg',
        subTitle: '全港動起來 向健康出發 為健康 一齊行',
        actTime: '活動日期:',
        process: ['報名開始（額滿即止）', '截止報名', '活動日'],
        actDetail: {
          title: '活動詳情',
          content: ['由中國移動香港及中國香港旅行遠足聯會主辦，香港少年領袖團全力支持，目的是推動全港市民參與，提高市民步行及行山的健康意識，由健康出發，加強「為健康，一齊行」信念。',
            '新春行大運鼓勵市民在2月17日結伴參與及一同享用新春盆菜，在節日共享歡樂時光。當日亦會舉辦新春行大運「萬步有禮」活動，鼓勵全港市民在全港任何一個角落一齊行，以健康的體魄迎接新一年。',
            '舉行日期 : 2019年2月17日',
            '活動時間：上午10時至下午3時',
            '報名日期：2019年1月31日 中午12:00 (先到先得)',
            '活動秘書處',
            '電話：2127 4720 (星期一至五早上10時至晚上7時)',
            '電郵：wewalk.enquiry@gmail.com'
          ]
        },
        route: {
          title: '行山路徑',
          startPoint: '起點：北潭涌 傷健樂園',
          routeList: [{
            name: '北潭涌 傷健樂園 至 香港少年領袖團萬宜訓練營',
            timeLabel: '行程：',
            time: '約2小時',
            lengthLabel: '長度：',
            length: '5.8公里',
            linkLabel: '詳情 >',
            link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=北潭涌傷健樂園→香港少年領袖團萬宜訓練營&lang=tc&/#/xingshan/route/11'
          }]
        },
        traffic: {
          title: '交通',
          content: ['自行乘坐公共交通工具到達集合地點，或乘坐大會專車由九龍塘出發',
            '公共交通：從西貢碼頭乘搭94號巴士至北潭涌站下車又或是乘搭7號或9號專線小巴於北潭涌下車']
        },
        submitConfirm: '參加活動'
      },
      sign: {
        title: '活動報名',
        nameLabel: '姓名',
        userName: '姓名',
        userNamePlaceholder: '請輸入姓名',
        phoneLabel: '手提電話',
        phonePlaceholder: '請輸入聯繫電話',
        emailLabel: '電郵地址',
        emailPlaceholder: '請輸入電郵地址',
        emergencyName: '緊急聯繫人姓名',
        emergencyNamePlaceholder: '請輸入緊急聯繫人姓名',
        emergencyPhone: '緊急聯繫人手提電話',
        emergencyPhonePlaceholder: '請輸入緊急聯繫人手提電話',
        extraListLabel: ['額外參與人員（限', '人）', '1'],
        addExtra: '添加額外參加人員',
        extraEmCheckbox: '使用和我相同的緊急聯絡人資料',
        rules1: {
          btn1: '「參加者須知及條款細則」',
          btn2: '「免責聲明」',
          btn3: '「個人資料收集聲明」',
          content: ['本人聲明本人已年滿18歲(年齡以活動當日計算)。本人及同行參加者細閱並同意本活動之', '、', '及', '。主辦機構保留取消不接受上述條款之參加者的參加資格。']
        },
        rules2: {
          content: ['本人聲明上述同行參加者中有18歲以下參加者。本人同意大會將會按本人所提供的電郵地址，以電郵提供家長/監護人同意書。本人明白必須於2019年2月15日或之前以電郵交回已簽署之家長/監護人同意書相關參加者才可參與本活動。主辦機構保留取消於限期前未能提交同意書之18歲以下參加者的參加資格。(18歲以下參加者適用，年齡以活動當日計算)']
        },
        submit: '提交資料',
        tip: {
          existEmail: '该电邮已被使用',
          notice: '提示',
          delExtra: '是否刪除此額外人員信息？',
          userName: '請輸入正確姓名',
          phone: '請輸入正確的手提電話',
          email: '請輸入正確电邮格式',
          emergencyPhone: '請輸入正確緊急聯繫人手提電話',
          emergencyName: '請輸入正確緊急聯繫人的姓名',
          extrName: '請輸入正確姓名',
          extrPhone: '請輸入正確的手提電話',
          extrEmergencyPhone: '請輸入正確緊急聯繫人手提電話',
          extrEmergencyName: '請輸入正確緊急聯繫人的姓名',
          extraExit: '此額外的參加者已報名，您可刪減或增加其他參加者'
        },
        rule1: {
          title: '活动条款及细则',
          content: [
            '「新春行大運」由中國移動香港有限公司(「中國移動香港」)及中國香港旅行遠足聯會(「旅聯」) 聯合主辦。',
            '在下列的條款及細則內「活動」乃指2019年2月17日舉行的「新春行大運」行山活動；「參加者」為參與是次活動的人士；「額外參加者」為參與是次活動的人士於報名時所申報同行的人士；「主辦機構」為中國移動香港及旅聯；「路線」是由主辦機構指定的行山路線。',
            '活動於2019年1月24日開始接受報名，採用先到先得形式報名，額滿後即時停止接受登記，亦不設候補名單。',
            '每名參加者可攜同一名額外參加者同行。報名者將是該組參加者的組長。',
            '參與活動確認一經遞交，即代表參加者及額外同行參加者確認及同意接受一切主辦機構不時所定之活動的規則、條款和安排。',
            '18歲以下參加者必須於[2019年2月15日]或之前以電郵(WeWalk.enquiry@gmail.com)方式向主辦機構提交已簽署之家長/監護人同意書。主辦機構保留取消於限期前未能提交同意書之18歲以下參加者的參加資格。'
          ]
        },
        rule2: {
          title: '活動細節',
          content: [
            '活動僅設有一條路線，起點為北潭涌傷健樂園，經北潭涌自然教育徑及上窰郊遊徑，終點為香港少年領袖團萬宜訓練營。每組參加者的組長必須於活動當日年滿18歲。所有參加者必須於活動當日年滿12歲。每名16歲以下之參加者必須由18歲或以上的成年人陪同參加。18歲以下的參加者必須事先獲家長或監護人簽署同意書方可參加。主辦機構保留在活動前後或進行期間，核實參加者年齡及(如有需要)該等同意書證明的權利。',
            '參加者於抵達終點香港少年領袖團萬宜訓練營後，主辦單位將於終點舉辦盆菜宴，並提供飲料。盆菜及飲料將由第三方機構提供。盆菜宴將於露天地方舉行，如遇惡劣天氣將移師至室內舉行。參加者可自行決定是否參與。',
            '主辦機構在得悉或懷疑情況下，保留、限制拒絕接受報名或取消任何不適宜參加本活動的參加權利，包括但不限於如申請者提供錯誤資料、不能提交報名表、不依從正確報名程序報名、或身體狀況不適宜參加本活動(如懷有身孕、患慢性疾病如心臟病及高血壓人士)。',
            '參加者必須最遲於活動當天上午9時45分抵達北潭涌傷健樂園，逾時者會被取消參加資格。若參加者未能按照其指定參加組別及時間起步，或未能依循所報名的路線完成活動，主辦機構有權取消其參加資格。',
            '參加者不可攜帶或使用任何滾軸鞋、滑板、手推車或其他大型物件，亦不可攜同任何動物參與。',
            '參加者於活動前後及進行期間，必須遵照主辦機構、授權人員以及其他工作人員包括警察、民眾安全服務隊、醫療輔助隊、食物環境衞生署及康樂及文化事務署的所有合法指示。',
            '參加者請於活動期間保持專業及禮貌的態度。',
            '步畢路線全程約2小時。沿途有上山路程，部分地區並無遮蓋，參加者需確保體力適宜才參與，如有疑問，應先向醫生查詢。由於鄰近萬宜水庫的道路為限制道路，沒有公共交通直達，如參加者未能步畢全程，可於中途退出，循原路折返起點。活動實際完結時間以主辦機構及授權人員所安排的押尾小隊決定為準。',
            '參加者需穿上合適的衣服及鞋襪，並自備充足飲品、食物、帽及雨具等。',
            '是次行山活動途徑泥路小徑，參加者須特別小心。請勿奔跑、爭先恐後、倚靠或攀爬沿途任何物件，以確保安全。',
            '參加者需自行承擔一切責任。主辦機構及授權機構並不會對參加者於活動當天因任何事情或理由所引致的任何個人傷亡或財物損失承擔任何責任。',
            '主辦機構保留更改條款細則、路線等安排的權利。',
            '主辦機構若認為參加者沒有完全遵照或違反本條款及細則的規定，主辦機構有權取消參加者的資格或於行山活動中任何時間內終止參加者繼續參加。主辦機構的判決為最終及不可推翻的決定。',
            '食品安全',
            '主辦機構將盡力確保食物安全，盆菜亦會徹底煮沸後才予參加者進食。',
            '提供盆菜及飲料的第三方機構或會在準備某些膳食時使用堅果和其他過敏原。主辦機構不能保證所提供的任何食物均不含過敏原。',
            '惡劣天氣',
            '如天文台於活動當日早上六時或之後懸掛黑色暴雨、紅色暴雨、雷暴或三號颱風警告，活動將會取消，主辦機構將另擇日子舉行活動。',
            '如活動進行中天氣惡劣或懸掛任何天氣警告，又或主辦機構評估後判斷當天並不適合舉行活動，主辦機構有權將活動路徑改變或取消正在進行中的活動。主辦機構不會另擇日子補辦活動。',
            '如是次活動因天氣惡劣或懸掛任何天氣警告或其他原因而取消，主辦機構將另行通知活動補辦日期。',
            '主辦機構強烈要求參加者於活動舉行當天早上致電香港天文台查詢天氣情況。(電話：1878200)',
            '其他事宜',
            '主辦機構不會提供行李寄存。切勿攜帶貴重物品，如有損毀或遺失，主辦機構將不會負任何責任及作出任何賠償。',
            '參加者如活動過程中須向主辦機構查詢及要求協助，請沿途與就近工作人員聯絡。',
            '所有由主辦機構提供的活動包、禮品及任何其他物品(「禮品」)不可兌換現金，亦不能更換、退款、轉讓及轉售。本活動所有的禮品視乎供應情況而定，換領完即止。每名參加者只可領取一份活動包，不可代他人領取。如任何因禮品所引起的爭議，主辦機構概不負責。',
            '主辦機構對供應商提供的商品或服務之品質、安全性及合法性，刊登內容之真實性及準確性，供應商的商譽與可信性均無控制力及保證。',
            '主辦機構已就活動購買第三者保險。參加者需自行負責個人意外保險。如參加者於活動開始前沒有於MyLink手機應用程式作電子簽到，則不獲活動第三者保險保障。',
            '主辦機構保留使用活動當天所拍得照片或錄像的權利，包括商業宣傳用途。',
            '主辦機構保留本活動的最終決定權。活動不設上訴機制。主辦機構擁有修改及解釋本條款規則的權利，任何有關活動的臨時改動或取消，將以主辦機構公布為準。',
            '本條款及細則受香港法律管轄。參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
            '本條款與細則的中、英文本如有任何歧義，概以英文本為準。',
            '如有任何爭議，主辦機構將保留一切最終決定權。'
          ]
        },
        rule3: {
          title: '免責聲明',
          label: '謹此聲明本人參加本活動，並願意遵守由主辦機構所訂的條文及規則，以及同意以下所列各點：',
          content: ['本人是自願參加此活動和願意承擔自身的意外風險及責任，並無權向主辦機構對本人往返活動場地途中、活動中發生或引致之自身意外、死亡或任何形式的損失提出索償或追討責任。',
            '本人聲明本人身體情況良好及有能力參加此活動，及沒有執業醫生曾提出相反意見。',
            '本人願意接受主辦機構要求及提供的藥物檢查及治療。',
            '本人於活動當天（2019年2月17日）已經符合參加組別之最低年齡規定（如參加者未年滿18歲，須由其家長或監護人簽署同意聲明）。',
            '本人明白及同意本人的個人資料將轉交予主辦機構用作活動安排之用途。',
            '本人證實已事先獲得同行參加者及/或緊急聯繫人的同意，可使用其個人資料於本活動的報名表格作報名及/或緊急聯繫用途。',
            '本人願意授權予及同意主辦機構及傳媒在不需要審查情況及不需要本人另外同意下而可使用本人的個人資料、肖像、姓名及聲線作為籌辦及推廣活動之用，包括本人肖像及姓名有可能被使用於主辦機構有關本活動之網頁、短片及刊物。',
            '本人提交確認即表示同意及確認所有列明之「參加者須知及條款細則」、「免責聲明」及「個人資料收集聲明」，以及所有不時於活動指定宣傳渠道更新的任何更改。'
          ]
        },
        rule4: {
          title: '個人資料收集聲明',
          label: '謹此聲明本人參加本活動，並願意遵守由主辦機構所訂的條文及規則，以及同意以下所列各點：',
          content: ['主辦機構將會在參加者報名參與「新春行大運」山頂行山活動並獲即時確認出席資格時，收集參加者的個人資料，包括姓名、手提電話號碼、電郵地址等。主辦機構保障參加者所提供之一切資料。當參加者提交確認時，有關個人資料將會被收集、儲存及使用以作核實。',
            '本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知您作為參加者收集資料的目的、您同意主辦機構如何使用這些資料及您的權利。本聲明會不時更改，故請定期查閱。參加者每次登記及/ 或使用我們的服務時，即表示同意接受當時生效之個人資料收集聲明。',
            '參加者可能會被要求向主辦機構提供個人識別資料。為讓參加者可以參加「新春行大運」行山活動，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得參賽資格。'
          ],
          title1: '資料之目的及用途',
          label1: '主辦機構所收集之資料將用作以下用途',
          content1: ['識別和核實參加活動的參加者的身份及/ 或資格;',
            '就有關或因參加活動的事項與參加者或其緊急聯繫人溝通;',
            '匯編參加者的整體統計資料，分析、評估及改進主辦機構所提供的活動.'
          ],
          title2: '資料之轉移',
          content2: ['參加者之個人資料將被保密。然而由於系統管理、運作及保養需要，主辦機構會將有關資料轉移或披露予對主辦機構有保密責任並提供與主辦機構運作有關行政、電訊、電腦系統服務、數據處理或其他服務的承辦商。',
            '參加者有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閱或更正參加者之個人資料。如有任何查閱或更正資料的要求，請向本公司資料保障主任提出，其辦事處位於香港新界葵涌葵昌路51號九龍貿易中心1座20樓。主辦機構的私隱政策聲明可於其網頁www.hk.chinamobile.com獲取。',
          ]
        }
      },
      result: {
        title: '活動報名',
        contactTitle: '「新春行大運」萬步有禮活動',
        contact: ['大會除了舉辦「新春行大運」活動，亦鼓勵全港市民在全港任何一個角落一齊行，以健康的體魄迎接新一年，特意舉辦「萬步有禮」活動。',
          '全港市民只要在2月17日當日開啟並登入MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可參加活動。'],
        list: [{
          label: '參加方法',
          li: ['登入MyLink',
            '開啟「生活」內 WeWalk 頁面',
            '當天行滿一萬步後，計步器將會發出提示']
        }, {
          label: '獎品',
          li: ['參加者只要成功在2月17 日行滿10,000步後，即可獲10000 MyLink 積分。（名額共1,000名，先到先得）']
        }],
        p: ['電話：2127 4720 (星期一至五早上10時至晚上7時)', '電郵：wewalk.enquiry@gmail.com'],
        success: {
          title: '活動報名',
          article: '參與活動成功！',
          info1: {
            label: '活動參與信息如下：',
            nameLabel: '姓名：',
            phoneLabel: '电话：',
            date: ['日期：', '2019年2月17日（星期日）'],
            time: ['時間：', '上午10時至下午3時'],
            route: ['集合地點：', '北潭涌 傷健樂園']
          },
          info2: {
            label: '額外參與人員信息：',
          },
          tips: ['主辦機構於活動前透過MyLink手機應用程式及電郵發出提示，屆時請留意活動最新資訊。']
        },
        beyond: {
          title: '活動報名',
          article: '抱歉！',
          info: ['感謝　閣下參與「新春行大運」活動。由於場地位置有限，活動已經額滿。下一季度的活動詳情將會適時公布。',
            '2月17日當天亦會舉行「萬步有禮」活動，敬請密切留意。']
        },
        // 签到
        fail: {
          title: '活動報名',
          article: '抱歉！',
          info: ['抱歉！當前報名人數過多，請稍後再試！']
        }
      }
    },
    query: {
      title: '萬步有禮',
      home: {
        btn: ['查閱活動紀錄','活動已結束','活動將於2月17日開始！'],
        time:['活動時間：2月17日'],
        content1: {
          title: '活動介紹',
          p: ['大會除了舉辦「新春行大運」活動，亦鼓勵全港市民在全港任何一個角落一齊行，以健康的體魄迎接新一年，特意舉辦「萬步有禮」活動。',
            '全港市民只要在2月17日當日開啟並登入MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可參加活動。']
        },
        content2: {
          title: '活動規則',
          p: ['登入MyLink',
            '開啟「生活」內 WeWalk 頁面',
            '當天行滿一萬步後，計步器將會發出提示（名額共1,000名，先到先得）']
        },
        content3: {
          title: '如何打開MyLink計步器參與活動？',
          p: ['參與活動前，請查看生活-WeWalk頁面步數資訊是否顯示正確（今日步數應大於0），如下圖：', 'static/newYear/question-tc.jpg', '如有問題，請點此','查看原因']
        },
        rules: {
          title: ['查看', '活動條款及細則'],
          content: [
            {
              title: '主辦機構',
              li: ['「新春行大運」萬步有禮活動由中國移動香港有限公司（「中國移動香港」或「主辦機構」）主辦。',
                '在下列的條款及細則內，「活動」乃指2019年2月17日舉行的「新春行大運」萬步有禮活動；「活動期間」乃指香港時間2019年2月17日00:00至當日23:59；「參加者」為參與是次活動的合資格人士；「得獎者」為首1,000名參與活動並在MyLink手機應用程式內錄得10,000步的參加者；「MyLink（手機應用程式）」為由中國移動香港推出的MyLink手機應用程式；「指定獎品」是由主辦機構指定的活動獎品，即MyLink積分10,000分。',
                '參加者一旦參與活動，即代表了解、同意並願意遵守本文所載的條款及細則，如有違反條款、以不誠實手法進行此活動及/或造假者，中國移動香港有權取消其參加及得獎資格，而不作任何通知。']
            }, {
              title: '參加資格',
              li: ['本活動只供年滿18歲並持有香港身份證人士參加。於確認得獎時，中國移動香港有權向得獎者要求提交證明文件以核對賬戶身份。如未能出示有關證明，其得獎資格將會被取消。',
                '參加者必須於活動期間內使用香港註冊的流動電話號碼註冊並登入MyLink參加本活動(每個香港流動電話號碼只限參加活動一次)。如發現參加者以外掛程式或其他非正式途徑如空號或假帳戶或其他影響公平性的方式參加本活動，中國移動香港將取消該參加者的資格而不作另行通知。',
                '首1,000名已登入MyLink帳戶的參加者於香港時間2019年2月17日00:00至當日23:59 (香港時間) 步行達10,000步或以上，即可獲得指定獎品。10,000步只以MyLink內計步功能計算為準，其他任何計步器紀錄恕不接受。',
                '參加者必須於Google Play 或 App Store 下載MyLink。中國移動香港客戶（包括現有的儲值卡客戶、服務計劃客戶及用身份證登記的企業客戶）需以電話號碼及客戶密碼登入MyLink；MySim客戶及非中國移動客戶需於活動專頁輸入電話及驗證碼登入MyLink。所有參加者必須同意本活動條款及細則，才可參加本活動。',
                '參加者必須提供支援短訊功能的香港手機號碼以獲得一次性驗證碼進行身份驗證。如登記的手機號碼不支援短訊功能或不能使用、無效或在領取禮品時已經更改，該得獎者資格會被取消。',
                '參加者必須於活動期間登入MyLink，並在計步期間一直開啟MyLink及維持流動數據功能，活動期間累計步數將由香港時間2019年2月17日00:00開始截至當日23:59為止。',
                '中國移動香港保留對參加者資格的最終決定權。',
                '活動日期於香港時間2019年2月17日00:00至當日23:59期間進行。參加者完成活動時間以中國移動香港伺服器紀錄之時間作準，逾時參與或完成將不獲受理。',
                '如活動第1,000名得獎者與其他參加者完成時間相同，則無論得獎者是否已累積至1,000名，該批參加者亦可獲發指定獎品。',
                '如主辦機構懷疑參加者有 （i）進行或與異常/可疑活動有關、（ii）使用不當的方法或欺詐行為而使本活動任何部份運作中斷或受到干擾，導致技術問題，或檢測到（iii）任何不誠實的行為、提供虛假或不正確的資料或（iv）任何違反本條款及細則或其他任何適用法律或條文；主辦機構擁有酌情權及最終決定權在不作任何通知及毋須對任何人士負上任何責任的情況下自行決定取消其參加及/或得獎資格，並對該人士保留追究權利。',
                '主辦機構不會對延遲、遺失、傳訊或無法識別參加者（包括但不限於任何電腦或互聯網絡之問題）提交的任何訊息引起或相關的事宜承擔任何責任。',
                '參加者於登記參加本活動時所提供的資料均不能更改。如登記頁面上所提供的資料有任何錯漏、不實或不正確，該登記則被視為無效。如得獎者因提供了虛假、錯漏或不正確的資料而導致無法收到領獎通知或不能領取禮品，主辦機構毋須為此承擔任何責任。',
                '主辦機構保留隨時更改本活動內容、終止本活動、修訂此條款及細則的權利，而無需另行通知。',
                '(i)MyLink和(ii) MyLink積分獎勵計劃的條款及細則將繼續適用。本活動受以上條款及細則約束。',
                '參加者對於是次活動及主辦單位的決定均不得異議。活動不設上訴機制。中國移動香港擁有修改及解釋以上規則的權利。如有任何爭議，中國移動香港保留最終決定權。',
                '本條款及細則受香港法律管轄。參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
                '本條款與細則的中、英文本如有任何歧義，概以英文本為準。',
                '除參加者和主辦機構外，任何人均不享有《合約(第三者權利)條例》下的任何權利，以執行或享有本條款及細則任何條文的利益。']
            }, {
              title: '參加須知',
              li: ['參加者須清楚明白本活動內容及性質，並知道本活動需要消耗體力，同時確定健康情況適宜參與本活動。主辦機構建議所有參加者於活動期間自行留意個人的身體狀況是否良好及是否適合參與本活動。參加者於活動期間如有不適，請立即停止活動，並按需要向醫護人員求助。',
                '參加者參加本活動純屬自願性質及需自行承擔參加本活動之風險。任何參加者因參加本活動而引致之任何損失、傷害、費用、索賠、訴訟（包括但不限於直接、間接及後果性損失），主辦機構概不負上任何法律責任或作出賠償。']
            }, {
              title: '有關MyLink計步功能',
              li: ['參加者必須於活動期間開啟MyLink及維持流動數據才能累積步數，如因任何技術中斷或錯誤、網絡擠塞或其他任何原因而產生或引致任何遲延、遺失、錯誤或無法辨識的回應、登記或提交等情況，主辦機構概不負責。參加者明白及同意不會就MyLink的數據提出任何異議。',
                '參加者可在活動期間登入MyLink，檢視MyLink計步器的步數。',
                '參加者明白不同裝置的計步器或有差距，一切結果會以主辦機構的電腦系統所示的步數紀錄為準。iOS裝置會存取Apple內置傳感器的步數紀錄；而Android裝置會存取內置計步器/加速度傳感器的步數紀錄，任何其他第三方之計步方式均不獲接受。',
                '計步功能只支援iOS版本9.0或以上及iPhone 5S或以上型號之手機，而Android手機則需內置計步感應器及系統為4.4或以上及之指定型號手機，並須視乎手機生產商對個別手機型號之設定為準。',
                '為確保MyLink可準確紀錄參加者的步行步數，主辦機構強烈建議參加者於每次步行前，到MyLink內的「生活」頁面按「開始計步」、再按圓形開始按鈕開始紀錄步數，並於完成步行後長按圓形停止按鈕停止紀錄步數。']
            }, {
              title: '指定獎品',
              li: ['經主辦機構驗證並確認得獎者指定獎品的獲獎資格後， MyLink積分10,000分將在2019年2月28日或之前自動存入得獎者註冊的MyLink帳戶。',
                'MyLink 積分餘額顯示在「我 - MyLink會員中心」頁面。',
                '根據本活動授予的MyLink積分可以與其他促銷活動或計劃下授予的MyLink積分累積使用，有效期至2019年12月31日。已兌換獎賞或已過期的MyLink積分不會在任何情況下獲發退款。',
                'MyLink積分沒有現金價值和不能兌換現金。MyLink積分不能售出，退款，購買，分配或轉讓。',
                '獲得MyLink積分後，得獎者可以在MyLink的「會員中心」兌換獎品。有關更多詳情，請參閱MyLink積分獎勵計劃的條款及細則。',
                '除特別註明外，本活動的指定獎品不可與其他優惠同時享用。',
                '欺詐和濫用行為將導致參加者喪失參與活動的資格。主辦機構保留暫停MyLink積分的派發、暫停相關MyLink賬戶或直接從相關MyLink賬戶扣除任何MyLink積分的權利，恕不另行通知。']
            }
          ]
        }
      },
      status: {
        btn: '邀請好友參與',
        back: '活動詳情',
        less: {
          title: '歡迎閣下參與活動',
          span: '活動期間累積步數：',
          p: ['今日步數', '距離獲得積分還差', '步，繼續加油哦！']
        },
        reach: {
          btn: '兌換禮品',
          tips: ['閣下已領取MyLink積分，感謝參與！'],
          rewards: ['在萬步有禮活動中已獲得', 'MyLink積分']
        },
        share:{
          title:'萬步有禮活動',
          content:'邀請參與萬步有禮活動'
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/locale/newYear/zh-hk.js